function parseInitializeEDeliveryData(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseHandleDocumentsData(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseMarkDocumentsAsReadData(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseDownloadDocumentsData(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseDocumentsForCategoriesData(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseDocumentsForOrder(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function parseFetchDocuments(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {
  const initializeEDelivery = ({ inputParam, metaData }) =>
    api
      .initializeEDelivery(inputParam, metaData)
      .then(parseInitializeEDeliveryData);

  const handleDocuments = ({ portfolioId, startDate, endDate, outputType, metaData }) =>
    api
      .handleDocuments(portfolioId, startDate, endDate, outputType, metaData)
      .then(parseHandleDocumentsData);

  const markDocumentsAsRead = ({ inputParam, metaData }) =>
    api
      .markDocumentsAsRead(inputParam, metaData)
      .then(parseMarkDocumentsAsReadData);

  const downloadDocuments = ({ inputParam, metaData }) =>
    api
      .downloadDocuments(inputParam, metaData)
      .then(parseDownloadDocumentsData);


  const fetchDocumentsForCategories = ({ inputParam, metaData }) =>
    api
      .fetchDocumentsForCategories(inputParam, metaData)
      .then(parseDocumentsForCategoriesData);

  const fetchDocumentsForOrder = ({ inputParam, metaData }) =>
    api
      .fetchDocumentsForOrder(inputParam, metaData)
      .then(parseDocumentsForOrder);

  const fetchDocuments = ({ inputParam, metaData }) =>
    api
      .fetchDocuments(inputParam, metaData)
      .then(parseFetchDocuments);

  const getStatementTypes = ({metaData}) =>
    api
      .getStatementTypes(metaData)
      .then(parseFetchDocuments);
      
  const createAdhocStatementReport = ({inputParam,metaData}) =>
    api
      .createAdhocStatementReport(inputParam,metaData)
      .then(parseFetchDocuments);
      
    

  return {
    initializeEDelivery,
    handleDocuments,
    markDocumentsAsRead,
    downloadDocuments,
    fetchDocumentsForCategories,
    fetchDocumentsForOrder,
    fetchDocuments,
    getStatementTypes,
    createAdhocStatementReport
  }
}

module.exports = serviceFactory;
